import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表

//系统管理相关接口
const myAllWork={
  //验证码
  verify(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/verify`,params);
  },
  //登录
  login(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sign`,params);
  },
  //退出登录
  loginOut(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/loginOut`,null);
  },
  //强制退出
  qzOut(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/qzOut/${params.loginid}`,null);
  },
  //左侧菜单列表
  leftMenus(params){
    return axios.get(`${base.bs}/admin/sys/tabMenus/leftMenus`,{params:params})
  },
  //用户列表-------------------------------用户管理相关-----------------------------------
  userPage(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabUser/page`,params);
  },
  //修改用户状态
  userChangeStatus(params){
    return axios.get(`${base.bs}/admin/sys/tabUser/upStatus/${params.id}/${params.status}`)
  },
  //根据id查询单个用户
  userGetById(params){
    return axios.get(`${base.bs}/admin/sys/tabUser/get/${params.id}`)
  },
  //保存、修改用户
  userSaveOrUpdate(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabUser/set`,params);
  },
  //根据id删除单个用户
  userDel(params){
    return axios.get(`${base.bs}/admin/sys/tabUser/del/${params.id}`)
  },
  //保存用户角色
  userRoleSave(params){
    return axios.get(`${base.bs}/admin/sys/tabUser/saveUserRole`,{params:params});
  },
  //调配部门
  editUserDept(params){
    return axios.post(`${base.bs}/admin/sys/tabUser/editDept`,params);
  },
  //密码修改
  userRpwd(params){
    return axios.post(`${base.bs}/admin/repwd/${params.ypass}/${params.pass}`,null);
  },
  //菜单列表-------------------------------菜单管理相关-----------------------------------
  menuPage(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabMenus/page`,params);
  },
  //所有菜单  树
  menuTree(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/admin/sys/tabMenus/getTree`,params);
  },
  //异步菜单  树
  ajaxMenuTree(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/admin/sys/tabMenus/ajaxTree/${params.parentId}`);
  },
  //根据id查询单个
  getMenuById(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/admin/sys/tabMenus/get/${params.id}`);
  },
  //添加修改  skipNulls: true  完全跳过值为 null 的键不解析
  saveOrUpMenu(params){
    return axios.post(`${base.bs}/admin/sys/tabMenus/set`,qs.stringify(params,{arrayFormat: 'brackets',skipNulls: true}));
  },
  //删除菜单
  menuDel(params){
    return axios.get(`${base.bs}/admin/sys/tabMenus/del/${params.id}`);
  },
  //角色列表-------------------------------角色管理相关-----------------------------------
  rolePage(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabRole/page`,params);
  },
  //某角色已有菜单
  roleMenuById(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/admin/sys/tabRole/getMenus/${params.id}`);
  },
  //保存角色-菜单对应关系--格式化参数中的数组arrayFormat
  roleMenuSave(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabRole/saveMenus`,qs.stringify(params,{arrayFormat: 'brackets'}));
  },
  //保存角色
  getRoleByid(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/admin/sys/tabRole/get/${params.id}`);
  },
  //保存角色
  roleSave(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabRole/set`,params);
  },
  //删除
  delRole(params){
    return axios.get(`${base.bs}/admin/sys/tabRole/del/${params.id}`);
  },
  //角色树
  getRoleTree(){
    return axios.get(`${base.bs}/admin/sys/tabRole/getRoleTree`)
  },
//----------------------------------------------字典管理----------------------------------------------
//  列表数据
  getDicPage(params){
    return axios.post(`${base.bs}/admin/sys/tabDic/page`,params);
  },
  //异步获取树子集
  ajaxDicTreeByPid(params){
    return axios.get(`${base.bs}/admin/sys/tabDic/ajaxTree/${params.parentId}`,{params:params});
  },
  //异步获取树子集getListByPcode
  ajaxDicListByPcode(params){
    return axios.get(`${base.bs}/admin/sys/tabDic/getListByPcode`,{params:params});
  },
  //异步获取树子集getListByPcode
  ajaxDicTreeAllByPcode(params){
    return axios.get(`${base.bs}/admin/sys/tabDic/ajaxTreeAllByPcode`,{params:params});
  },
  //根据主键查询
  getDicByid(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/admin/sys/tabDic/get/${params.id}`);
  },
  //保存字典
  saveOrUpdateDic(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabDic/set`,qs.stringify(params,{arrayFormat: 'brackets',skipNulls:true}));
  },
  //删除
  dicDel(params){
    return axios.get(`${base.bs}/admin/sys/tabDic/del/${params.id}`);
  },
  //----------------------------------------------部门管理----------------------------------------------
//  列表数据
  getDepartmentPage(params){
    return axios.post(`${base.bs}/admin/sys/tabDepartment/page`,params);
  },
  //异步获取树子集
  ajaxDepartmentTreeByPid(params){
    return axios.get(`${base.bs}/admin/sys/tabDepartment/ajaxTree/${params.parentId}`,{params:params});
  },
  //根据主键查询
  getDepartmentByid(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/admin/sys/tabDepartment/get/${params.id}`);
  },
  //保存字典
  saveOrUpdateDepartment(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabDepartment/set`,params);
  },
  //删除
  deptmentDel(params){
    return axios.get(`${base.bs}/admin/sys/tabDepartment/del/${params.id}`);
  },
}
// 导出接口
export  default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/sys.js